import { Controller } from "@hotwired/stimulus"

// Draws attention to the lanparty switcher in the top bar: scrolls it into view
// and pings it for a moment, so "switch above" points at something concrete.
export default class extends Controller {
    static values = { target: { type: String, default: "[data-lanparty-switcher]" } }

    highlight() {
        const switcher = document.querySelector(this.targetValue)
        if (!switcher) return

        switcher.scrollIntoView({ behavior: "smooth", block: "center" })

        // Restart the animation even if it is already running.
        switcher.classList.remove("mng-lanparty--ping")
        void switcher.offsetWidth
        switcher.classList.add("mng-lanparty--ping")

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => switcher.classList.remove("mng-lanparty--ping"), 3000)

        // Open the dropdown so the choice is one click away.
        switcher.querySelector("[data-bs-toggle='dropdown']")?.click()
    }

    disconnect() {
        clearTimeout(this.timeout)
    }
}
